import { useQuery } from 'react-query'
import { useParams } from 'react-router-dom'
import { getFinancialHistoryUserInfo } from 'services/financialHistory'

export default function useGetUserInfo() {
    const { moneyPool, poolship } = useParams()
    const { data, isLoading } = useQuery(
        ['financial-history-user-info', moneyPool, poolship],
        getFinancialHistoryUserInfo
    )
    return { userInfo: data, isLoadingUserInfo: isLoading }
}
